import {
  Paper,
} from '@mui/material';
import React from 'react';
import {SupportSlotWeekDayComponent} from '../shared/SupportSlotWeekDayComponent';
import {SupportSlotDefinitionCreateDrawer} from './components/SupportSlotDefinitionCreateDrawer';
import {SupportSlotDefinitionPreviewDrawer} from './components/SupportSlotDefinitionPreviewDrawer';
import {useSupportSlotDefinitionPageState} from './state/support-slot-definition-page-state';

export const SupportSlotDefinitionPage = () => {
  const state = useSupportSlotDefinitionPageState()

  return (
    <>
      {
        state.drawerOpen && <SupportSlotDefinitionCreateDrawer
          weekday={state.selectedWeekday!}
          isDrawerOpen={state.drawerOpen}
          onDrawerClosed={() => state.setDrawerOpen(false, null)}
          refreshSlotDefinitions={state.refreshSlotDefinitions}
        />
      }
      {
        state.slotPreviewDrawerOpen && <SupportSlotDefinitionPreviewDrawer
          initialSlotDefinition={state.selectedSlot!}
          isDrawerOpen={state.slotPreviewDrawerOpen}
          refreshSlotDefinitions={state.refreshSlotDefinitions}
          onDrawerClosed={() => {
            state.setSlotPreviewDrawerOpen(false, null)
          }}
        />
      }
      <SupportSlotWeekDayComponent
        slots={state.slotDefinitions}
        onAddSlotPressed={(weekday) => state.setDrawerOpen(true, weekday)}
        onSlotPressed={(slot) => {
          state.setSlotPreviewDrawerOpen(true, slot)
        }}
      />
    </>
  );
};
